/* ============================================================
   QUICK CROCHET COURSE — Theme JavaScript
   Authentic behavior matching quickcrochet.shop:
   - Inline countdown "42h 11m" in the sticky urgency banner
   - Mobile sticky bottom bar (always visible on mobile)
   - AJAX add-to-cart with cart drawer
   - Scroll-in animations, product gallery thumbs
   ============================================================ */

(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* ---- Inline Countdown ("42h 11m" format, persisted per session) ---- */
  function initCountdown() {
    var els = document.querySelectorAll('[data-countdown-inline]');
    if (!els.length) return;

    els.forEach(function (el) {
      var hours = parseInt(el.dataset.countdownHours || '42', 10);
      var stored = sessionStorage.getItem('qcc_countdown_end');
      var end;
      if (stored && parseInt(stored, 10) > Date.now()) {
        end = parseInt(stored, 10);
      } else {
        end = Date.now() + hours * 3600000;
        sessionStorage.setItem('qcc_countdown_end', end);
      }

      var hEl = el.querySelector('[data-hours]');
      var mEl = el.querySelector('[data-minutes]');

      function tick() {
        var remaining = end - Date.now();
        if (remaining <= 0) {
          if (hEl) hEl.textContent = '0h';
          if (mEl) mEl.textContent = '0m';
          return;
        }
        var h = Math.floor(remaining / 3600000);
        var m = Math.floor((remaining % 3600000) / 60000);
        if (hEl) hEl.textContent = h + 'h';
        if (mEl) mEl.textContent = m + 'm';
        setTimeout(tick, 30000);
      }
      tick();
    });
  }

  /* ---- Cart Drawer ---- */
  function openCart() {
    var drawer = document.getElementById('CartDrawer');
    var overlay = document.getElementById('CartOverlay');
    if (!drawer) return;
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }

  function closeCart() {
    var drawer = document.getElementById('CartDrawer');
    var overlay = document.getElementById('CartOverlay');
    if (!drawer) return;
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function initCartDrawer() {
    var toggle = document.getElementById('CartToggle');
    var close = document.getElementById('CartDrawerClose');
    var overlay = document.getElementById('CartOverlay');

    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        openCart();
      });
    }
    if (close) close.addEventListener('click', closeCart);
    if (overlay) overlay.addEventListener('click', closeCart);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCart();
    });

    // Bind quantity / remove buttons rendered by Liquid
    bindCartItemEvents();
  }

  function bindCartItemEvents() {
    var body = document.getElementById('CartDrawerBody');
    if (!body) return;

    body.querySelectorAll('[data-action="decrease"], [data-action="increase"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.cart-item');
        var variantId = btn.dataset.variant;
        var qtyEl = item.querySelector('.qty-select span');
        var current = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
        var next = btn.dataset.action === 'increase' ? current + 1 : current - 1;
        updateCartItem(variantId, Math.max(0, next));
      });
    });

    body.querySelectorAll('.cart-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateCartItem(btn.dataset.variant, 0);
      });
    });
  }

  function updateCartItem(variantId, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        refreshCartDrawer();
      })
      .catch(function () {});
  }

  function updateCartCount(count) {
    var el = document.getElementById('CartCount');
    if (!el) return;
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---- Re-render cart drawer from /cart.js ---- */
  function refreshCartDrawer() {
    var body = document.getElementById('CartDrawerBody');
    var footer = document.getElementById('CartDrawerFooter');
    if (!body) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);

        if (cart.item_count === 0) {
          body.innerHTML =
            '<div class="cart-empty">' +
              '<p class="cart-empty__icon">🧶</p>' +
              '<p style="font-weight:700;color:var(--brown-dark)">Your cart is empty</p>' +
            '</div>';
          if (footer) footer.innerHTML = '';
          return;
        }

        var html = cart.items.map(function (item) {
          var img = item.image
            ? '<img src="' + item.image + '&width=120" alt="" loading="lazy" onerror="this.src=\'' + item.image + '\'">'
            : '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:1.5rem">🧶</div>';
          return (
            '<div class="cart-item" data-variant-id="' + item.variant_id + '">' +
              '<div class="cart-item__image">' + img + '</div>' +
              '<div class="cart-item__info">' +
                '<div class="cart-item__title">' + item.product_title + '</div>' +
                '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
                '<div class="qty-select" style="margin-top:.5rem">' +
                  '<button type="button" data-action="decrease" data-variant="' + item.variant_id + '" aria-label="Decrease">−</button>' +
                  '<span style="padding:0 .75rem;font-size:.9rem">' + item.quantity + '</span>' +
                  '<button type="button" data-action="increase" data-variant="' + item.variant_id + '" aria-label="Increase">+</button>' +
                '</div>' +
              '</div>' +
              '<button type="button" class="cart-item__remove" data-variant="' + item.variant_id + '" aria-label="Remove">✕</button>' +
            '</div>'
          );
        }).join('');
        body.innerHTML = html;
        bindCartItemEvents();

        if (footer) {
          footer.innerHTML =
            '<div class="cart-summary__row"><span>Subtotal</span><span id="CartSubtotal">' + formatMoney(cart.total_price) + '</span></div>' +
            '<a href="/checkout" class="btn btn--cta btn--full" style="padding:1rem;font-size:1rem">🔒 Secure Checkout</a>';
        }
      })
      .catch(function () {});
  }

  /* ---- AJAX Add to Cart ---- */
  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-add-to-cart-form], form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('[data-add-to-cart]') || form.querySelector('[type="submit"]');
      var variantInput = form.querySelector('[name="id"]');
      if (!variantInput) return;

      var originalText = btn ? btn.innerHTML : '';
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = 'Adding…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantInput.value, 10), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          if (item.status) throw new Error(item.description || 'Error');
          openCart();
        })
        .catch(function (err) {
          alert(err.message || 'Could not add to cart. Please try again.');
        })
        .finally(function () {
          if (btn) {
            btn.disabled = false;
            btn.innerHTML = btn.dataset.defaultText || originalText;
          }
        });
    });
  }

  /* ---- Mobile Sticky Bottom Bar ---- */
  function initMobileStickyBar() {
    var bar = document.getElementById('MobileStickyBar');
    var btn = document.getElementById('MobileStickyBtn');
    if (!bar) return;

    document.body.classList.add('has-mobile-bar');

    if (btn) {
      btn.addEventListener('click', function () {
        var topForm = document.getElementById('ProductFormTop');
        if (topForm) {
          topForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      });
    }
  }

  /* ---- Product Gallery Thumbnails ---- */
  function initProductGallery() {
    var thumbs = document.querySelectorAll('.product-gallery__thumb');
    var main = document.getElementById('ProductMainImage');
    if (!thumbs.length || !main) return;

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        thumbs.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var src = btn.dataset.src;
        if (src) {
          main.style.opacity = '0';
          main.style.transition = 'opacity .2s ease';
          var img = new Image();
          img.onload = function () {
            main.src = src;
            main.style.opacity = '1';
          };
          img.src = src;
        }
      });
    });
  }

  /* ---- Scroll-in Animations ---- */
  function initScrollAnimations() {
    var els = document.querySelectorAll('[data-animate]');
    if (!els.length) return;
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('animated');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      els.forEach(function (el) { observer.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('animated'); });
    }
  }

  /* ---- Init ---- */
  document.addEventListener('DOMContentLoaded', function () {
    initCountdown();
    initCartDrawer();
    initAddToCart();
    initMobileStickyBar();
    initProductGallery();
    initScrollAnimations();
  });

})();
